export enum TrainingModalityEnum {
  ONLINE = "ONLINE",
  IN_PERSON = "IN_PERSON",
  HYBRID = "HYBRID",
  VIRTUAL_CLASSROOM = "VIRTUAL_CLASSROOM",
}

export const getTrainingModalityLabel = (modality: TrainingModalityEnum): string => {
  switch (modality) {
    case TrainingModalityEnum.ONLINE:
      return "Online";
    case TrainingModalityEnum.IN_PERSON:
      return "Presencial";
    case TrainingModalityEnum.HYBRID:
      return "Mixta";
    case TrainingModalityEnum.VIRTUAL_CLASSROOM:
      return "Aula virtual";
  }
};

export const getTrainingModalityOptions = (): { value: TrainingModalityEnum; label: string }[] => {
  const keys = Object.keys(TrainingModalityEnum).filter(
    (key: string) => typeof TrainingModalityEnum[key as keyof typeof TrainingModalityEnum] === "string",
  );
  return keys.map((val) => {
    const value = TrainingModalityEnum[val as keyof typeof TrainingModalityEnum];
    return { label: getTrainingModalityLabel(value), value };
  });
};
